import DeliveryNoteList from '../components/DeliveryNote/DeliveryNoteList';

export default function DeliveryNoteListPage() {
  return <DeliveryNoteList />;
}